
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class ReporteEmbarqueSector4Service {
  static async getDataReporteEmbarqueSector4 (cereal, cerealVariedad, etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_vejez_sector4?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}","etiqueta":"${etiqueta}","etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de embarque sector 4.')
      return (data)
    })
  }

  static async getDataReporteEmbarqueSector4Total (cereal, cerealVariedad, etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_vejez_sector4_total?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}","etiqueta":"${etiqueta}","etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de embarque sector 4.')
      return (data)
    })
  }
}
